import { LocalEnum } from "#/enum";
import { Icon } from "@/components/icon";
import useLocale, { LANGUAGE_MAP } from "@/locales/use-locale";
import { Button } from "@/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/ui/dropdown-menu";

type Locale = keyof typeof LocalEnum;

// 判断是否生产环境
const isProduction = import.meta.env.VITE_APP_ENV === "production";

/**
 * Locale Picker
 */
export default function LocalePicker() {
	const { setLocale, locale } = useLocale();

	// 生产环境：只显示英文（可用）和韩文（置灰）
	// 开发环境：显示所有语言
	const localeList = isProduction
		? [
				{
					key: LocalEnum.zh_CN,
					label: LANGUAGE_MAP[LocalEnum.zh_CN].label,
					icon: <Icon icon={`local:${LANGUAGE_MAP[LocalEnum.zh_CN].icon}`} size="20" className="rounded-md" />,
					disabled: false,
				},
				{
					key: LocalEnum.en_US,
					label: LANGUAGE_MAP[LocalEnum.en_US].label,
					icon: <Icon icon={`local:${LANGUAGE_MAP[LocalEnum.en_US].icon}`} size="20" className="rounded-md" />,
					disabled: false,
				},
				{
					key: LocalEnum.ko_KR,
					label: LANGUAGE_MAP[LocalEnum.ko_KR].label,
					icon: (
						<Icon icon={`local:${LANGUAGE_MAP[LocalEnum.ko_KR].icon}`} size="20" className="rounded-md opacity-50" />
					),
					disabled: true,
				},
			]
		: Object.values(LANGUAGE_MAP).map((item) => ({
				key: item.locale,
				label: item.label,
				icon: <Icon icon={`local:${item.icon}`} size="20" className="rounded-md" />,
				disabled: false,
			}));

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button variant="ghost" size="icon" className="rounded-full">
					{/* <Icon icon={`local:${LANGUAGE_MAP[locale].icon}`} size="20" /> */}
					{LANGUAGE_MAP[locale].label}
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent className="z-[9999]">
				{localeList.map((item) => (
					<DropdownMenuItem
						key={item.key}
						onClick={() => !item.disabled && setLocale(item.key as Locale)}
						disabled={item.disabled}
						className={item.disabled ? "opacity-50 cursor-not-allowed" : ""}
					>
						{item.icon}
						{item.label}
					</DropdownMenuItem>
				))}
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
